import React, { createContext, useContext } from 'react';

import {
  TResourceDetailContext,
  TResourceDetailProvider,
} from '@/shared/components/ui/resource-detail/context/resource-detail-context.types';

const ResourceDetailContext = createContext<TResourceDetailContext>({
  isCompact: false,
});

export const useResourceDetailContext = (): TResourceDetailContext =>
  useContext(ResourceDetailContext);

export const ResourceDetailProvider: React.FC<TResourceDetailProvider> = ({
  isCompact,
  children,
}) => (
  <ResourceDetailContext value={{ isCompact }}>
    {children}
  </ResourceDetailContext>
);
